import '../style/modal-D5-IHeqg.css'
import { defineComponent as C, inject as f, openBlock as r, createElementBlock as k, renderSlot as s, normalizeProps as y, guardReactiveProps as _, unref as l, createBlock as $, mergeProps as U, createCommentVNode as b, createTextVNode as j, toDisplayString as R, ref as L, watch as Q, useModel as ce, useSlots as de, computed as p, provide as D, nextTick as W, onMounted as me, isRef as ue, withCtx as h, createElementVNode as N, normalizeClass as B, normalizeStyle as pe, withModifiers as K, withKeys as Y, createVNode as E } from "vue";
import X from "./icon-button.js";
import { pxlize as fe } from "x-utils";
import { unrefElement as ve, tryOnScopeDispose as he } from "@vueuse/core";
import { createFocusTrap as ke } from "focus-trap";
import ye from "./internalComponents/CloseIcon.js";
import { useMobileView as _e } from "./hooks/useMobileView.js";
import be from "./spinner.js";
import { getSpaceClass as z, SpaceTypeEnum as H } from "./utils/style.js";
import { INPUT_EVENT as ge, UPDATE_MODEL_VALUE as q, CLOSE_EVENT as G, BACK_EVENT as J } from "./constant/events.js";
import { useAnimateClick as Pe } from "./hooks/useAnimateClick.js";
import $e from "./internalComponents/Overlay.js";
const F = Symbol("e-modal-close"), M = Symbol("e-modal-back"), Z = Symbol("e-modal-header-icon"), Ce = { class: "e-modal-content" }, Se = /* @__PURE__ */ C({
  name: "e-modal-content",
  __name: "modal-content",
  setup(m) {
    const a = f(F), e = f(M);
    return (n, t) => (r(), k("div", Ce, [
      s(n.$slots, "default", y(_({ close: l(a), back: l(e) })))
    ]));
  }
}), Ie = { class: "e-modal-header" }, we = {
  key: 0,
  class: "e-modal-header-title"
}, Te = {
  key: 1,
  class: "e-modal-header-desc"
}, Be = /* @__PURE__ */ C({
  name: "e-modal-header",
  __name: "modal-header",
  props: {
    title: {},
    description: {}
  },
  setup(m) {
    const a = f(F), { back: e } = f(M), n = f(Z);
    return (t, v) => (r(), k("div", Ie, [
      s(t.$slots, "top"),
      l(n) ? (r(), $(l(X), U({ key: 0 }, l(n), {
        class: "e-modal-header-icon",
        "hover-scale": ""
      }), null, 16)) : b("", !0),
      s(t.$slots, "default", y(_({ close: l(a), back: l(e) })), () => [
        t.$slots.title || t.title ? (r(), k("div", we, [
          s(t.$slots, "title", {}, () => [
            j(R(t.title), 1)
          ])
        ])) : b("", !0),
        t.$slots.description || t.description ? (r(), k("div", Te, [
          s(t.$slots, "description", {}, () => [
            j(R(t.description), 1)
          ])
        ])) : b("", !0)
      ])
    ]));
  }
}), Ee = { class: "e-modal-footer" }, Fe = /* @__PURE__ */ C({
  name: "e-modal-footer",
  __name: "modal-footer",
  setup(m) {
    const a = f(F), e = f(M);
    return (n, t) => (r(), k("div", Ee, [
      s(n.$slots, "default", y(_({ close: l(a), back: l(e) })))
    ]));
  }
}), Me = /* @__PURE__ */ C({
  __name: "modal-back-icon",
  setup(m) {
    return (a, e) => (r(), $(l(X), {
      icon: "arrow-left",
      class: "e-modal-back"
    }));
  }
});
function Oe(m, a = {}) {
  let e;
  const { immediate: n, ...t } = a, v = L(!1), i = L(!1), g = (c) => e && e.activate(c), S = (c) => e && e.deactivate(c), I = () => {
    e && (e.pause(), i.value = !0);
  }, O = () => {
    e && (e.unpause(), i.value = !1);
  };
  return Q(
    () => ve(m),
    (c) => {
      c && (e = ke(c, {
        ...t,
        onActivate() {
          v.value = !0, a.onActivate && a.onActivate();
        },
        onDeactivate() {
          v.value = !1, a.onDeactivate && a.onDeactivate();
        }
      }), n && g());
    },
    { flush: "post" }
  ), he(() => S()), {
    hasFocus: v,
    isPaused: i,
    activate: g,
    deactivate: S,
    pause: I,
    unpause: O
  };
}
const Ve = { class: "e-modal-layout-wrapper" }, Ae = {
  key: 2,
  class: "e-modal__loading"
}, Ge = /* @__PURE__ */ C({
  name: "e-modal",
  inheritAttrs: !1,
  __name: "modal",
  props: {
    modelValue: { type: Boolean },
    persistent: { type: Boolean },
    mobileFullScreen: { type: Boolean, default: !0 },
    mobileFullScreenTransition: {},
    closeIcon: { type: Boolean, default: !0 },
    backIcon: { type: Boolean },
    theme: {},
    closeHandler: {},
    headerPadding: {},
    contentPadding: {},
    footerPadding: {},
    title: {},
    description: {},
    size: {},
    loading: { type: Boolean },
    overflow: { type: Boolean },
    width: {},
    blockingScroll: { type: Boolean, default: !0 },
    overlayOptions: {},
    headerIcon: {}
  },
  emits: [
    ge,
    q,
    G,
    J
  ],
  setup(m, { emit: a }) {
    const e = m, n = a, t = L(), { isMobile: v } = _e(), i = ce(e, "modelValue", { local: !0 }), { activate: g, deactivate: S } = Oe(t, {
      immediate: !0,
      clickOutsideDeactivates: !0,
      fallbackFocus: "body"
      // fallback element when there is no focusable element in modal
    }), { animate: I, animateClick: O } = Pe(), c = de(), x = p(() => ({
      ...{
        blockingScroll: e.blockingScroll ?? !0
      },
      ...e.overlayOptions
    })), V = p(() => {
      const o = !!c.header || !!e.title || !!e.description, d = !!c.footer, u = e.backIcon ? 48 : 24, ae = o ? 24 : 12, ne = [0, 24], se = d ? 24 : 12, le = e.contentPadding ?? ne, re = e.headerPadding ?? [u, 24, ae], ie = e.footerPadding ?? [se, 24];
      return {
        header: re,
        content: le,
        footer: ie
      };
    }), w = p(() => {
      const o = z(H.Padding, V.value.header), d = z(H.Padding, V.value.content), u = z(H.Padding, V.value.footer);
      return {
        body: [
          {
            "e-modal-mobile--fullscreen": e.mobileFullScreen,
            "e-modal--animated": I.value,
            "e-modal--loading": I.value,
            [`e-modal--${e.size}`]: e.size
          },
          e.theme
        ],
        content: [d],
        header: [o],
        footer: [u]
      };
    }), ee = p(() => {
      const o = {};
      return e.width && (o.width = fe(e.width)), o;
    }), oe = p(() => e.mobileFullScreen && v.value ? e.mobileFullScreenTransition ?? "e-modal-bottom-transition" : "e-modal-transition"), te = (o) => {
      o && o.stopPropagation(), e.persistent ? O() : P();
    }, P = () => {
      e.closeHandler ? e.closeHandler() : (n(q, !1), n(G));
    }, T = () => {
      n(J);
    }, A = p(() => ({
      close: P,
      back: T
    }));
    return D(F, P), D(M, {
      back: T,
      backIcon: p(() => e.backIcon)
    }), D(Z, e.headerIcon), Q(i, (o) => {
      o ? W(() => {
        g();
      }) : S(), n("input", o);
    }), me(() => {
      i.value && W(() => {
        g();
      });
    }), (o, d) => (r(), $($e, U({
      open: l(i),
      "onUpdate:open": d[1] || (d[1] = (u) => ue(i) ? i.value = u : null)
    }, x.value, {
      transition: oe.value,
      variant: "modal",
      "overlay-click": te
    }), {
      default: h(({ zIndex: u }) => [
        N("div", U({
          ref_key: "modalWrapperRef",
          ref: t,
          role: "dialog",
          "aria-modal": "true",
          class: "e-modal-wrapper",
          "data-overlay": "true",
          style: { zIndex: u }
        }, o.$attrs), [
          N("div", {
            class: B(["e-modal", w.value.body]),
            style: pe(ee.value),
            onClick: d[0] || (d[0] = K(() => {
            }, ["stop"]))
          }, [
            s(o.$slots, "prepend"),
            N("div", Ve, [
              o.closeIcon ? (r(), $(ye, {
                key: 0,
                class: "e-modal-close",
                onClick: P,
                onKeydown: Y(K(P, ["stop", "prevent"]), ["space", "enter"])
              }, null, 8, ["onKeydown"])) : b("", !0),
              o.backIcon ? (r(), $(Me, {
                key: 1,
                onClick: T,
                onKeydown: Y(K(T, ["stop", "prevent"]), ["space", "enter"])
              }, null, 8, ["onKeydown"])) : b("", !0),
              s(o.$slots, "default", {}, () => [
                E(Be, {
                  class: B(w.value.header),
                  title: o.title,
                  description: o.description,
                  "back-icon": o.backIcon
                }, {
                  title: h(() => [
                    s(o.$slots, "title")
                  ]),
                  description: h(() => [
                    s(o.$slots, "description")
                  ]),
                  default: h(() => [
                    s(o.$slots, "header", y(_(A.value)))
                  ]),
                  _: 3
                }, 8, ["class", "title", "description", "back-icon"]),
                E(Se, {
                  class: B(w.value.content)
                }, {
                  default: h(() => [
                    s(o.$slots, "content", y(_(A.value)))
                  ]),
                  _: 3
                }, 8, ["class"]),
                E(Fe, {
                  class: B(w.value.footer)
                }, {
                  default: h(() => [
                    s(o.$slots, "footer", y(_(A.value)))
                  ]),
                  _: 3
                }, 8, ["class"])
              ]),
              o.loading ? (r(), k("div", Ae, [
                E(l(be), {
                  size: 40,
                  "color-scheme": "primary",
                  "stroke-width": 3
                })
              ])) : b("", !0)
            ])
          ], 6)
        ], 16)
      ]),
      _: 3
    }, 16, ["open", "transition"]));
  }
});
export {
  Me as ModalBackIcon,
  M as ModalBackInjectionKey,
  F as ModalCloseInjectionKey,
  Se as ModalContent,
  Fe as ModalFooter,
  Be as ModalHeader,
  Z as ModalHeaderIconInjectionKey,
  Ge as default
};
//# sourceMappingURL=modal.js.map
